<script lang="ts">
	import type { Media } from "@core/schema/Media.js";
	import MediaComponent from "./common/Media.svelte";
	import type { MediaSrc } from "./common/MediaSrc.js";

	const componentId = $props.id();
	const {
		mediaSrc,
		secondary = false,
		alt,
		eager = false,
		class: mediaClass,
	}:
		| { mediaSrc: MediaSrc; secondary?: false; alt: string; eager?: boolean; class?: string }
		| { mediaSrc: Media; secondary: true; alt: string; eager?: boolean; class?: string } = $props();
</script>

<MediaComponent
	{alt}
	{eager}
	preload={secondary ? "low" : eager ? "high" : undefined}
	width={328}
	height={328}
	source={mediaSrc}
	sourcesets={{
		"<2xs": [459, 459],
		">2xs": [500, 500],
		">md": [610, 610],
		">lg": [414, 414],
		">xl": [408, 408],
	}}
	lightbox={"youtube" in mediaSrc && componentId}
	wrapperClass={[
		"absolute inset-0 size-full bg-inherit",
		secondary &&
			"z-10 pointer-events-none opacity-0 [a:hover>&]:opacity-100 group-hover/product-card:opacity-100 transition-opacity duration-500",
	]}
	lightboxClass="!absolute inset-0 size-full"
	class={["size-full object-cover", mediaClass]}
/>
